/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react'

import StrikeZoneGeneric from './StrikeZones/Generic.tsx'
import StrikeZoneDumb from './StrikeZones/Dumb.tsx'
import StrikeZoneFuzzy from './StrikeZones/Fuzzy.tsx'

import getStrikeZoneDims from './StrikeZones/get-strike-zone-dims.ts'
import {
    useChartOptions,
    useLocationAccurate_TODOFIX,
    useScales,
    useShouldShowNormalized,
    useStrikeZoneType,
} from '../../Context/ChartContext.tsx'
import canBePersonalized from './StrikeZones/can-be-personalized.ts'
import shouldShowNormalized from './StrikeZones/should-show-normalized.ts'
import StrikeZoneFuzzyForeground from './StrikeZones/FuzzyForeground.tsx'

const colors = {
    average: '#111',
    personal: '#111',
    generic: '#111',
    'generic-old': '#111',
    fuzzy: '#111',
}

function StrikeZone() {
    const { chartOptions, settings } = useChartOptions()
    const { xScale, yScale } = useScales()

    const strikeZone = useStrikeZoneType()
    const isPersonal = strikeZone === 'personal'

    const strikeZoneDims = getStrikeZoneDims(strikeZone, settings.data)

    const strokeDasharray = isPersonal ? 'none' : '8 2.5'

    const isLocationAccurate = useLocationAccurate_TODOFIX()

    if (isLocationAccurate) {
        return <StrikeZoneFuzzyForeground />
    }

    // Only necessary while isLocationAccurate is kneecapped
    const showNormalized = useShouldShowNormalized()
    const actualLocationAccurate = !isPersonal && !showNormalized

    const strokeColor = actualLocationAccurate ? '#888' : colors[strikeZone]

    switch (strikeZone) {
        // case 'generic-old':
        case 'personal':
        case 'average':
        case 'generic':
            return (
                <StrikeZoneDumb
                    xScale={xScale}
                    yScale={yScale}
                    szTop={strikeZoneDims.top}
                    szBot={strikeZoneDims.bot}
                    plateWidthFt={strikeZoneDims.width}
                    // Todo: Send specific stroke color?
                    styles={{ stroke: strokeColor, strokeDasharray }}
                />
            )
        case 'fuzzy':
            return (
                <StrikeZoneFuzzy
                    xScale={xScale}
                    yScale={yScale}
                    data={settings.data}
                />
            )
        default:
            return (
                <StrikeZoneGeneric
                    xScale={xScale}
                    yScale={yScale}
                    chartOptions={chartOptions}
                />
            )
    }
}

function QuickRuler({ yScale }: { yScale: d3.ScaleLinear<number, number> }) {
    const y = yScale(6)
    const height = yScale(0) - y
    const width = 8
    const tickWidth = 12
    const ticks = [0, 1, 2, 3, 4, 5, 6]
    return (
        <g>
            <rect y={y} height={height} width="8" fill="#ccc" />
            {ticks.map((tick) => (
                <g key={tick} transform={`translate(0, ${yScale(tick) - 1})`}>
                    <text dx={-tickWidth - 2} dy={2} dominantBaseline="middle">
                        {tick}
                    </text>
                    <rect
                        x={-tickWidth + width}
                        // y={yScale(tick) - 1}
                        height={2}
                        fill="#666"
                        width={tickWidth}
                    />
                </g>
            ))}
        </g>
    )
}

const showCycler = false

export default function StrikeZoneWrapper() {
    const { cycleStrikeZone, updateChartOptions, chartOptions, settings } =
        useChartOptions()
    const strikeZone = useStrikeZoneType()
    const { yScale } = useScales()

    const canBePersonal = canBePersonalized(settings.data)
    const showNormalized = shouldShowNormalized(chartOptions, strikeZone)

    return (
        <>
            {showCycler && (
                <>
                    <text
                        onClick={() => {
                            cycleStrikeZone(canBePersonal)
                        }}
                        x={250}
                        fontSize="16"
                        textAnchor="middle"
                        style={{ cursor: 'pointer' }}
                    >
                        Zone: {strikeZone}
                    </text>
                    <text
                        x={250}
                        y={30}
                        textAnchor="middle"
                        onClick={() => {
                            updateChartOptions({ normalize: !showNormalized })
                        }}
                        fontSize="16"
                        style={{ cursor: 'pointer' }}
                    >
                        {showNormalized
                            ? 'Scale: Normalized (to generic)'
                            : 'Scale: Actual'}
                    </text>
                </>
            )}
            {showCycler && <QuickRuler yScale={yScale} />}
            <StrikeZone />
        </>
    )
}
